module.exports = __webpack_public_path__ + "img/1586882974.c43c78af.jpg";